import {Type} from '@angular/core';
import {StepRuleSelectComponent} from './step-rule-select/step-rule-select.component';
import {StepFileSelectComponent} from './step-file-select/step-file-select.component';

/**
 * Registry mapping interaction types (from InteractionSpec.type) to Angular components.
 * Add new entries here to support additional interactive step types without
 * modifying the execution component.
 */
export const STEP_COMPONENT_REGISTRY: Record<string, Type<any>> = {
  'rule_select': StepRuleSelectComponent,
  'file_select': StepFileSelectComponent,
};

/**
 * Resolves the component for a given interaction type.
 * Returns undefined if no specific component is registered (execution component
 * will show a generic fallback or loading state).
 */
export function resolveStepComponent(interactionType: string): Type<any> | undefined {
  return STEP_COMPONENT_REGISTRY[interactionType];
}

/**
 * Returns all registered interaction types.
 */
export function getRegisteredInteractionTypes(): string[] {
  return Object.keys(STEP_COMPONENT_REGISTRY);
}
